import { Link } from 'react-router-dom'
import { catalogSongs } from '../data/songs'
import { CoverArt } from '../components/CoverArt'

export function MusicPage() {
  return (
    <div className="page">
      <header className="page-header">
        <p className="page-kicker">Catalog</p>
        <h1 className="page-title">Music</h1>
        <p className="page-desc">
          The full AIAS catalog — music videos, lyrics, and free MP3 downloads.
        </p>
      </header>
      <div className="catalog">
        {catalogSongs.map((song) => (
          <Link key={song.slug} to={`/music/${song.slug}`} className="card">
            <div className="card-media">
              <CoverArt song={song} />
              <span className="card-watch">Watch</span>
            </div>
            <div className="card-body">
              <h2 className="card-title">{song.title}</h2>
              <p className="card-tag">{song.tagline}</p>
            </div>
          </Link>
        ))}
      </div>
      <div className="archive-door">
        <Link to="/music/demo-archive">Demo Archive</Link>
      </div>
    </div>
  )
}
